import safeLoadLocale from '@cdo/apps/util/safeLoadLocale';

let locale = safeLoadLocale('dance_locale');
module.exports = locale;
